// extracted by mini-css-extract-plugin
module.exports = {"description":"Lgejy","links":"_3Bv0G"};